export const nfeStatusEnum = {
  EDITING: 0,
  PROCESSING: 1,
  REJECTED: 2,
  CANCELED: 3,
  AUTHORIZED: 4,
};
